export const LOCALIZATION_DEFAULT_LOCALE = 'en-US';

export const LOCALIZATION_DEFAULT_NUMBER = {
    decimalSeparator: '.',
    thousandSeparator: ','
};

export const LOCALIZATION_DEFAULT_PREFERRED_UNIT = 'KG';
export const LOCALIZATION_DEFAULT_TIMEZONE = 'Europe/Berlin';
